<template>
  <div class="lookup-service-places-wrapper">
    <v-card class="mb-1" v-if="selectedItem">
      <v-card-title>
        <h6>Selected Location:</h6>
      </v-card-title>
      <v-card-text>
        {{ locationAddress }}
      </v-card-text>
    </v-card>
    <v-autocomplete
      v-model="selectedItem"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :error="customError"
      :error-messages="errorMessage"
      :disabled="controlDisabled == true"
      hide-no-data
      hide-selected
      no-filter
      outlined
      clearable
      placeholder="Start typing to search"
      prepend-inner-icon="mdi-office-building-marker-outline"
      full-width
      return-object
      :readonly="readonlyStatus"
      @update:search-input="onUpdateSearchInput"
      @click:clear="onClear"
    >
    </v-autocomplete>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedItem: {},
      search: null,
      items: [],
      isLoading: false,
      baseUrl: "api/DynamicCrf/",
      errorMessage: "",
      customError: false,
      readonlyStatus: false,
    };
  },
  props: [
    "value",
    "required",
    "dataItemId",
    "controlDisabled",
    "placeType",
    "error",
    "error-messages",
  ],
  watch: {
    search: async function(val) {
      await this.fetchPlaces(val);
    },
    required: function() {
      this.validateControl();
    },
    selectedItem: function({ value, text } = {}) {
      if (value) {
        this.items = Object.assign([], [{ value, text }]);
      } else {
        this.items = Object.assign([]);
      }
      this.validateControl();
      this.$emit("input", value);
    },
  },
  methods: {
    validateControl: function() {
      this.errorMessage = "";
      if (this.required && !this.value) {
        this.errorMessage = "This is required";
        this.$store.commit("appendErrorItem", {
          id: this.dataItemId,
          msg: this.errorMessage,
        });
        this.customError = true;
      } else {
        this.$store.commit("removeErrorItem", {
          id: this.dataItemId,
          msg: this.errorMessage,
        });
        this.customError = false;
      }
    },
    fetchPlaces: async function(searchTerm) {
      if (this.selectedItem || (searchTerm && searchTerm.length < 5)) return;
      if (this.isLoading) return;
      this.isLoading = true;
      let sData = {
        searchTerm: searchTerm,
        placeType: this.placeType,
      };
      let actionUrl = `${this.baseUrl}GetPlaceNames`;
      const { data: rData } = await axios.post(actionUrl, sData);
      if (rData) {
        this.items = Object.assign([], rData);
      }
      this.isLoading = false;
    },
    getPlaceItem: async function(orgCode) {
      if (!orgCode) return;
      this.isLoading = true;

      let actionUrl = `${this.baseUrl}GetPlaceNameText`;
      const { data: rData } = await axios.get(actionUrl, {
        params: { orgCode: orgCode },
      });

      if (rData) {
        this.items = Object.assign([], rData);
        this.selectedItem = rData[0];
        this.readonlyStatus = true;
      }
      this.isLoading = false;
    },
    onUpdateSearchInput: function(searchTerm) {
      if (!searchTerm) {
        this.selectedItem = "";
      }
    },
    onClear: function() {
      this.readonlyStatus = false;
    },
  },
  computed: {
    locationAddress: function() {
      if (this.selectedItem) {
        const { text } = this.selectedItem;
        return text;
      } else {
        return "";
      }
    },
    locationCode: function() {
      if (this.selectedItem) {
        const { value } = this.selectedItem;
        return value;
      } else {
        return "";
      }
    },
  },
  beforeDestroy: function() {
    this.$store.commit("removeErrorItem", {
      id: this.dataItemId,
      msg: this.errorMessage,
    });
  },
  async mounted() {
    if (this.value) {
      await this.getPlaceItem(this.value);
    }
  },
};
</script>
<style>
.lookup-service-places-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.v-list-item__title,
.v-list-item__subtitle {
  white-space: normal !important;
}
.lookup-service-places-wrapper .v-progress-linear {
  height: 5px !important;
}
</style>
